import { __assign, __rest } from "tslib";
import React from 'react';
import { withBemMod } from '@bem-react/core';
import { cnButtonGroup } from '../ButtonGroup';
import './ButtonGroup_gap_m.css';
/**
 * Модификатор, делающий из ссылки псевдоссылку.
 * @param {ButtonGroupProps} props
 */
export var withGapM = withBemMod(cnButtonGroup(), { gap: 'm' }, function (ButtonGroup) {
    return function (props) {
        var gap = props.gap, restProps = __rest(props, ["gap"]);
        return React.createElement(ButtonGroup, __assign({}, restProps, { gap: gap }));
    };
});
